import { marked } from 'marked';

export function processMarkdown(text: string): string {
  return String(marked.parse(text, { async: false, gfm: true, breaks: true }));
}
